<template>
  <div class="vue-button-group">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'vueButtonGroup'
  };
</script>
